/**
 * 常量池，更多请参见 ./README.md
 *
 * 要求：src/const 文件夹下定义的常量都需要添加注释！！！
 */
import Vue from 'vue'

Vue.prototype.$const = {
  enterpriseWorkbenchId: 90005424, // 企业在线工作台Id
  // 自定义列表格式化类型,用于任务项展示
  displayType: {
    direct: 'direct', // 不做处理直接展示
    date: 'date', // 日期类型，展示为yyyy-MM-dd格式
    time: 'time', // 日期时间类型，展示位yyyy-MM-dd hh:mm:ss格式
    area: 'area', // 省市区，可根据城市码转换成城市，或直接展示
    dict: 'dict', // 字典类型：{key: key, value: value}
    amount: 'amount', // 金额，分为单位
    flatDict: 'flatDict', // 字典数组: [{key: key, value: value}]
    hyperLink: 'hyperLink', // 超链接类型，需要跳转页面
    rate: 'rate' // 比率
  },
  // 下拉框默认值：--全部--
  selectAll: '--全部--'
}
